import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitosaputaracab() {



const cardData = {
  keyword: " Mumbai to Saputara Cabs",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Saputara cab services for travelers planning a scenic hill station getaway in Gujarat. Saputara, known as the only hill station in Gujarat, is famous for its lush green landscapes, cool climate, and peaceful surroundings in the Sahyadri hills. Whether you are planning a relaxing weekend trip, a family vacation, a romantic getaway, or a group outing, our cab service ensures a safe and smooth journey with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way cab service, round-trip packages, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in hill and highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Saputara cab booking.",

topPlaces: [
  {
    title: "Saputara Lake",
    description:
      "Saputara Lake is one of the most popular attractions in the hill station and is located near the main town center. The lake is man-made and surrounded by lush greenery and scenic hills, making it a peaceful spot for relaxation and boating. Visitors can enjoy paddle boating, lakeside walks, and photography while taking in the cool mountain breeze. A cab trip from Mumbai to Saputara allows travelers to comfortably reach the lake and spend quality time exploring nearby gardens, viewpoints, and local markets. :contentReference[oaicite:0]{index=0}"
  },
  {
    title: "Sunset Point",
    description:
      "Sunset Point in Saputara, also known as Gandhi Shikhar, is one of the most famous viewpoints in the hill station. Visitors gather here in the evening to watch the sun slowly disappear behind the Sahyadri hills, creating breathtaking colors across the sky and valley. The viewpoint offers panoramic views of forests, valleys, and waterfalls, making it a favorite spot for photography and relaxation. Travelers arriving by cab can easily access this scenic location and enjoy a peaceful sunset experience during their Saputara trip. :contentReference[oaicite:1]{index=1}"
  },
  {
    title: "Saputara Ropeway",
    description:
      "The Saputara Ropeway is one of the most exciting attractions in the hill station, offering an aerial ride between Sunset Point and Sunrise Point. The ropeway ride provides stunning views of Saputara Lake, the surrounding hills, and dense forests, making it a memorable experience for tourists and families. The short ride lasts a few minutes but offers incredible panoramic views of the region from above. Travelers visiting Saputara by cab can easily include this adventure activity in their sightseeing itinerary for a unique perspective of the hill station. :contentReference[oaicite:2]{index=2}"
  },
  {
    title: "Gira Waterfall",
    description:
      "Gira Waterfall is one of the most beautiful natural attractions near Saputara, located close to the town of Waghai. The waterfall becomes especially spectacular during the monsoon season when water cascades dramatically into the Ambika River below. Visitors come here for scenic views, photography, and peaceful moments in nature surrounded by lush greenery. A comfortable cab journey from Mumbai allows travelers to visit this stunning waterfall while exploring other nearby attractions around Saputara. :contentReference[oaicite:3]{index=3}"
  },
  {
    title: "Saputara Tribal Museum",
    description:
      "Saputara Tribal Museum showcases the culture, lifestyle, and traditions of the tribal communities living in the Dang region of Gujarat. The museum displays artifacts such as traditional costumes, ornaments, musical instruments, tools, and ritual objects used by local tribes. Visitors can learn about tribal art, customs, and the region’s rich cultural heritage. Traveling by cab makes it convenient to explore this cultural attraction along with other sightseeing spots in Saputara during a relaxed day of exploration. :contentReference[oaicite:4]{index=4}"
  },
  {
    title: "Echo Point",
    description:
      "Echo Point is a fascinating viewpoint in Saputara where visitors can hear their voices echo through the surrounding hills and valleys. The location is known for its natural acoustics and scenic beauty, offering views of nearby forests and waterfalls. Travelers often visit this spot for fun experiences, photography, and peaceful nature walks. A cab trip to Saputara ensures easy access to this attraction and allows visitors to enjoy the natural environment without worrying about transportation. :contentReference[oaicite:5]{index=5}"
  },
  {
    title: "Step Garden",
    description:
      "Step Garden is a beautifully landscaped garden in Saputara designed with a unique step-like layout across the hillside. The garden features colorful flowers, lush plants, and well-maintained pathways that create a peaceful environment for relaxation and photography. Visitors often spend time here enjoying the cool climate and scenic surroundings. Traveling by cab from Mumbai allows tourists to comfortably include this garden as part of their Saputara sightseeing itinerary."
  },
  {
    title: "Rose Garden",
    description:
      "Rose Garden in Saputara is a charming attraction filled with a variety of roses and other flowering plants that bloom throughout the year. The garden is a peaceful spot where visitors can enjoy nature, take photographs, and relax amidst colorful floral displays. Families and couples often visit to enjoy the calm atmosphere and scenic beauty. A cab journey from Mumbai ensures convenient travel to Saputara and allows travelers to explore this garden along with nearby viewpoints and parks. :contentReference[oaicite:6]{index=6}"
  },
  {
    title: "Hatgad Fort",
    description:
      "Hatgad Fort is a historic hill fort located near Saputara on the Maharashtra-Gujarat border. The fort offers breathtaking views of the surrounding Sahyadri hills and valleys and is popular among trekking enthusiasts and history lovers. Built centuries ago, the fort stands at an elevation of around 3,600 feet and provides an adventurous hiking experience. Travelers visiting Saputara by cab can easily include Hatgad Fort in their itinerary for a combination of history, trekking, and scenic exploration. :contentReference[oaicite:7]{index=7}"
  },
  {
    title: "Purna Wildlife Sanctuary",
    description:
      "Purna Wildlife Sanctuary is a dense forest reserve located near Saputara and is part of the Western Ghats ecosystem. The sanctuary is home to diverse wildlife species including deer, bears, wild bulls, and many bird species, making it an excellent destination for nature lovers and wildlife enthusiasts. Visitors can explore forest trails, observe biodiversity, and enjoy peaceful natural surroundings. A cab trip from Mumbai provides convenient access to this sanctuary and allows travelers to combine wildlife exploration with their Saputara hill station getaway. :contentReference[oaicite:8]{index=8}"
  }
],



services: [
{
name: "Mumbai to Saputara Cab",
description: "Mumbai to Saputara cab service provides comfortable transportation from Mumbai to the beautiful hill station of Saputara located in Gujarat. The route passes through scenic highways and is ideal for tourists planning a relaxing hill station getaway. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, offices, railway stations, and airport terminals across Mumbai. Vehicles are well maintained and suitable for long-distance travel. Spacious seating ensures comfortable journeys for families and groups. Flexible booking options allow convenient travel planning."
},
{
name: "Mumbai to Saputara Taxi",
description: "Mumbai to Saputara taxi service offers reliable long-distance transportation for travelers visiting the popular Saputara hill station. Vehicles provide comfortable seating and smooth highway performance suitable for extended journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel, family trips, and weekend getaways. Air-conditioned vehicles ensure comfortable travel experiences. Flexible booking options allow easy taxi reservations."
},
{
name: "Mumbai to Saputara Cab Service",
description: "Mumbai to Saputara cab service offers dependable transportation for travelers planning trips to the scenic hill station of Saputara. Vehicles are suitable for long highway journeys and provide comfortable seating for passengers. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for holiday travel, tourism visits, and family trips. Comfortable interiors ensure relaxed journeys. Flexible booking options allow convenient ride reservations."
},
{
name: "Mumbai to Saputara Taxi Service",
description: "Mumbai to Saputara taxi service provides convenient travel options for tourists visiting Saputara for sightseeing and relaxation. Vehicles offer smooth highway performance and spacious seating for long-distance travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airports. Ideal for weekend trips, tourism visits, and family vacations. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow easy taxi scheduling."
},
{
name: "Cab from Mumbai to Saputara",
description: "Cab from Mumbai to Saputara offers comfortable interstate transportation for travelers planning visits to the Saputara hill station. Vehicles are suitable for highway travel and provide comfortable seating for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for tourism travel, family trips, and holiday tours. Spacious vehicles ensure comfortable journeys. Flexible booking options allow easy ride reservations."
},
{
name: "Taxi from Mumbai to Saputara",
description: "Taxi from Mumbai to Saputara provides reliable travel options for passengers visiting Saputara for sightseeing and vacations. Vehicles are designed for highway journeys and offer comfortable seating for long-distance travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for weekend getaways, tourism travel, and family trips. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow easy taxi reservations."
},
{
name: "Mumbai to Saputara Cab Booking",
description: "Mumbai to Saputara cab booking allows travelers to easily reserve vehicles for hill station trips and long-distance journeys. Online and phone booking options provide instant confirmation and convenient ride scheduling. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family vacations, tourism travel, and weekend trips. Comfortable vehicles ensure relaxed travel experiences. Flexible booking options allow easy reservations anytime."
},
{
name: "Mumbai to Saputara Taxi Booking Online",
description: "Mumbai to Saputara taxi booking online provides convenient digital reservations for travelers planning hill station trips. Passengers can easily schedule pickups and receive instant confirmations for their journey. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for families, tourists, and corporate travelers. Air-conditioned vehicles ensure comfortable journeys. Flexible online booking options allow easy travel planning."
},
{
name: "Mumbai to Saputara Cab Price",
description: "Mumbai to Saputara cab price options provide transparent fare estimates for travelers planning hill station trips. Pricing depends on vehicle category, travel distance, and trip duration. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family trips, tourism visits, and weekend getaways. Comfortable vehicles ensure relaxed journeys. Transparent pricing ensures affordable travel planning."
},
{
name: "Mumbai to Saputara Taxi Fare",
description: "Mumbai to Saputara taxi fare services offer flexible pricing based on vehicle type and travel distance. Travelers can choose sedan, SUV, or MPV vehicles depending on comfort preferences and budget. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for tourism travel, family trips, and holiday journeys. Comfortable interiors ensure relaxed journeys. Transparent fare structure allows easy travel planning."
},
{
name: "Mumbai to Saputara Hill Station Cab",
description: "Mumbai to Saputara hill station cab service provides comfortable transportation for tourists visiting the scenic hill station in Gujarat. Vehicles are suitable for long-distance travel and provide smooth highway performance. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel, weekend trips, and family vacations. Spacious vehicles ensure comfortable journeys. Flexible booking options allow convenient travel planning."
},
{
name: "Mumbai to Saputara One Way Cab",
description: "Mumbai to Saputara one way cab service offers economical intercity travel without return charges. Vehicles provide comfortable seating and smooth highway travel for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel and hill station visits. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow quick ride reservations."
},
{
name: "Mumbai to Saputara Round Trip Taxi",
description: "Mumbai to Saputara round trip taxi service provides convenient transportation for travelers planning return journeys from the hill station. Vehicles are suitable for long-distance highway travel and multi-day trips. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family vacations and tourism travel. Comfortable interiors ensure relaxed journeys. Flexible round-trip packages allow convenient travel planning."
},
{
name: "Mumbai to Saputara Innova Cab",
description: "Mumbai to Saputara Innova cab service provides spacious MPV transportation ideal for family and group travel. The Toyota Innova offers comfortable seating and smooth highway performance suitable for long-distance journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism trips and family vacations. Comfortable interiors ensure relaxed journeys. Flexible booking options allow convenient travel planning."
},
{
name: "Mumbai to Saputara Ertiga Cab",
description: "Mumbai to Saputara Ertiga cab service offers comfortable MPV transportation suitable for families and small groups traveling to Saputara. The Maruti Ertiga provides spacious seating and smooth ride quality for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism visits and weekend trips. Air-conditioned interiors ensure comfortable journeys. Flexible booking options allow easy ride reservations."
}
],

tableData: [
["Mumbai to Saputara Cab","Mumbai to Saputara Taxi"],
["Mumbai to Saputara Cab Service","Mumbai to Saputara Taxi Service"],
["Cab from Mumbai to Saputara","Taxi from Mumbai to Saputara"],
["Mumbai to Saputara Cab Booking","Mumbai to Saputara Taxi Booking Online"],
["Mumbai to Saputara Cab Price","Mumbai to Saputara Taxi Fare"],
["Mumbai to Saputara Hill Station Cab","Mumbai to Saputara One Way Cab"],
["Mumbai to Saputara Round Trip Taxi","Mumbai to Saputara Innova Cab"],
["Mumbai to Saputara Ertiga Cab","Saputara Tour Cab from Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Hill Route Drivers",
    WhyChoosedescription: "Our drivers are experienced in driving through the scenic ghat roads from Mumbai to Saputara. They are familiar with hill routes, curves, and changing weather conditions, ensuring a safe and smooth journey to Gujarat’s popular hill station."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Mumbai to Saputara cab bookings. Customers receive clear information about per-kilometer rates, toll charges, and travel packages before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our Mumbai to Saputara cab service operates 24 hours a day. Whether you want to start early in the morning or travel overnight, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, regularly cleaned, and fully air-conditioned to ensure passengers enjoy a comfortable long-distance journey."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Packages",
    WhyChoosedescription: "We offer flexible travel options including one-way cab booking, round trips, and multi-day travel packages for Mumbai to Saputara hill station trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers various vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for families and groups."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your Saputara trip begins smoothly."
  },
  {
    WhyChooseheading: "Trusted Hill Station Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Mumbai to Saputara hill station trips. Our punctual drivers, comfortable vehicles, and professional service ensure a relaxing travel experience."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai to Saputara?", answer: "Yes, Omshree Cabs provides reliable cab services from Mumbai to Saputara hill station for one-way and round-trip travel." },
  { question: "What is the distance from Mumbai to Saputara?", answer: "The distance from Mumbai to Saputara is approximately 250 km and the journey usually takes around 5 to 6 hours depending on traffic and road conditions." },
  { question: "Can I book a one-way cab from Mumbai to Saputara?", answer: "Yes, we offer both one-way and round-trip cab services between Mumbai and Saputara." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on group size." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Mumbai to Saputara cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, sightseeing, or refreshment breaks." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and tourist seasons." },
  { question: "Can we visit Saputara Lake and Sunset Point?", answer: "Yes, travelers can visit popular attractions like Saputara Lake, Sunset Point, Gira Waterfalls, and the Ropeway during their trip." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Shah",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Saputara trip. The driver handled the hill roads very well and the car was clean and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Mehta",
    feedback:
      "Excellent cab service for Saputara hill station travel. Smooth ride, professional driver, and very reliable service.",
    rating: 5
  }
];











































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Saputara Cabs",
  "description": "Omshree Cab offers reliable cab services from Mumbai to Saputara for one-way and round trips. Travel comfortably to the hill station with Innova, Ertiga, and other well-maintained vehicles. Enjoy safe, punctual, and convenient journeys with flexible booking options and transparent pricing for family trips, group travel, and leisure tours.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "950"
  }
};









  return (
    <div>
      
<Helmet>
  <title>Mumbai to Saputara Cabs | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides cab services from Mumbai to Saputara for one-way and round trips. Travel to the hill station with Innova, Ertiga, and other vehicles. Safe, punctual, and convenient journeys with flexible booking options and transparent pricing." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/63.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitosaputaracab;